import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/Icon";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const LandingPage = () => {
  return (
    <div className="bg-white" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <SiteTitle title="خشکشویی آکسون | صفحه اصلی" />

      <section className="bg-primary-50 flex-grow-1 d-flex align-items-center" style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 text-center text-lg-end mb-40 mb-lg-0 pe-lg-5">
              <h1 className="display-5 fw-black text-neutral-900 mb-24 line-height-1-4">
                مراقبت از لباس‌های شما، <br /><span className="text-primary-600">تخصص ماست</span>
              </h1>
              <p className="text-secondary-light text-lg mb-40 line-height-1-8">
                خشکشویی آکسون با بهره‌گیری از جدیدترین تجهیزات و مواد شوینده استاندارد، بالاترین کیفیت شستشو، لکه‌بری و اتوکشی را برای شما به ارمغان می‌آورد.
                تمیزی و لطافت را با ما تجربه کنید.
              </p>
              <div className="d-flex gap-3 justify-content-center justify-content-lg-start">
                <a href="tel:02112345678" className="btn btn-primary px-32 py-16 radius-8 text-md d-flex align-items-center gap-2 fw-semibold">
                  <Icon icon="solar:phone-calling-outline" className="text-xl" />
                  تماس با پشتیبانی
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center">
              <img src="/assets/images/main.jpg" alt="خشکشویی آکسون" className="img-fluid max-w-400-px drop-shadow-sm" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-80-px bg-white">
        <div className="container">
          <div className="text-center mb-56" style={{ paddingTop: 20 }}>
            <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=7798714&Code=v6hv6Tw3u4ScW1NbsA9Ji9eNeG1TExwt'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=7798714&Code=v6hv6Tw3u4ScW1NbsA9Ji9eNeG1TExwt' alt='' style={{ cursor: 'pointer' }} code='v6hv6Tw3u4ScW1NbsA9Ji9eNeG1TExwt' /></a>
          </div>
        </div>
      </section>
      
      <section className="py-80-px bg-white">
        <div className="container">
          <div className="text-center mb-56" style={{ paddingTop: 20 }}>
            <h2 className="fw-bold text-neutral-900 mb-16">خدمات تخصصی آکسون</h2>
            <p className="text-secondary-light text-md">بهترین و سریع‌ترین خدمات مراقبت از پوشاک</p>
          </div>
          <div className="row g-4">
            {/* آیتم 1 */}
            <div className="col-md-3 col-sm-6">
              <div className="card h-100 border border-neutral-100 shadow-sm radius-16 text-center p-24 hover-scale transition-2 bg-hover-neutral-50">
                <div className="bg-primary-50 text-primary-600 w-72-px h-72-px rounded-circle d-flex align-items-center justify-content-center mx-auto mb-20">
                  <Icon icon="solar:washing-machine-outline" className="text-3xl" />
                </div>
                <h5 className="fw-semibold mb-12">شستشوی تخصصی</h5>
                <p className="text-secondary-light text-sm mb-0 line-height-1-6">استفاده از شوینده‌های ملایم و استاندارد برای حفظ بافت پارچه</p>
              </div>
            </div>
            {/* آیتم 2 */}
            <div className="col-md-3 col-sm-6">
              <div className="card h-100 border border-neutral-100 shadow-sm radius-16 text-center p-24 hover-scale transition-2 bg-hover-neutral-50">
                <div className="bg-primary-50 text-primary-600 w-72-px h-72-px rounded-circle d-flex align-items-center justify-content-center mx-auto mb-20">
                  <Icon icon="solar:hanger-outline" className="text-3xl" />
                </div>
                <h5 className="fw-semibold mb-12">اتوکشی حرفه‌ای</h5>
                <p className="text-secondary-light text-sm mb-0 line-height-1-6">اتوکشی با دستگاه‌های پیشرفته بخار بدون ایجاد برق‌افتادگی</p>
              </div>
            </div>
            {/* آیتم 3 */}
            <div className="col-md-3 col-sm-6">
              <div className="card h-100 border border-neutral-100 shadow-sm radius-16 text-center p-24 hover-scale transition-2 bg-hover-neutral-50">
                <div className="bg-primary-50 text-primary-600 w-72-px h-72-px rounded-circle d-flex align-items-center justify-content-center mx-auto mb-20">
                  <Icon icon="solar:waterdrops-outline" className="text-3xl" />
                </div>
                <h5 className="fw-semibold mb-12">لکه‌بری تضمینی</h5>
                <p className="text-secondary-light text-sm mb-0 line-height-1-6">تشخیص و رفع سخت‌ترین لکه‌ها توسط متخصصین مجرب</p>
              </div>
            </div>
            {/* آیتم 4 */}
            <div className="col-md-3 col-sm-6">
              <div className="card h-100 border border-neutral-100 shadow-sm radius-16 text-center p-24 hover-scale transition-2 bg-hover-neutral-50">
                <div className="bg-primary-50 text-primary-600 w-72-px h-72-px rounded-circle d-flex align-items-center justify-content-center mx-auto mb-20">
                  <Icon icon="solar:routing-2-outline" className="text-3xl" />
                </div>
                <h5 className="fw-semibold mb-12">پیک اختصاصی</h5>
                <p className="text-secondary-light text-sm mb-0 line-height-1-6">دریافت و تحویل لباس‌ها در محل شما با پیک اختصاصی</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* فوتر */}
      <footer className="bg-neutral-900 text-neutral-400 py-24 text-center mt-auto">
        <div className="container">
          <p className="mb-0 text-sm">© {new Date().getFullYear()} تمامی حقوق برای خشکشویی آکسون محفوظ است.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;